import baseAPI from '@/http'

const router = 'api/pergunta-faixa-resposta'

export const cityFaixaAPI = {
    create: (faixa) => baseAPI.post(router, faixa),
    update: (faixa) => baseAPI.put(router, faixa),
    delete: (id) => baseAPI.delete(`${router}/${id}`),
    list: () => baseAPI.get(router),
    get: (id) => baseAPI.get(`${router}/${id}`),
    getByPerguntaFaixaId: (perguntaFaixaId) => baseAPI.get(`${router}/get-perguntas-faixa-resposta-by-faixaId/${perguntaFaixaId}`),

}
